import React, {forwardRef, memo, useRef, useEffect, useCallback} from 'react'
import _ from '/home/ps/root'
import {cache, equal, copy, Fields, cookies} from '../../global'
// import { usePark } from '../../hook/park'
const ID = 'header'
// const Header = forwardRef((prop, ref) => {
const Header = prop => {
  const { param, uarr, darr, u, io, cookie, login, master, verb: _verb } = prop.master
  // const park = prop.park
  // const { park, setPark } = usePark()
  const { db, v, count, park } = prop
  const { storeConfig, sell } = prop.table
  // const {stale, title, desc, file, icon, meta, onClick: callback} = prop
  const { title, desc, file, icon, meta, onClick: callback } = prop
  const pk = prop.table && prop.table.pk
  const verb = prop.row ? prop.row.verb : _verb
  let collapse// = prop.row ? prop.row.collapse : prop.table.collapse
  if (title) collapse = prop.table.collapse
  else if (desc) collapse = prop.row.collapse
  const printer = park[v] && park[v][verb]
  const I = printer ? (printer.part[v].i.i || printer.part[v].i) : master[v] && master[v].i
  const headerClass = ['header', v]
  if (pk) headerClass.push(`pk${pk}`)
  headerClass.push(verb)
  if (collapse && prop.row) headerClass.push(prop.row.stale ? 'stale' : '')
  // if (prop.compact) headerClass.push('compact')
  const pTitle = {className: ['title', 'theme', 'center', 'h1']}
  const pDesc =  {className: ['desc', 'theme', 'center', 'h1']}
  // const pTitle = {className: ['title', 'theme', 'h1']}
  // const pDesc =  {className: ['desc', 'theme', 'h1']}
  // if (storeConfig) pDesc.className.push('center')
  // if (prop.storeConfig) pDesc.className.push('center')
  // const elementRef = useRef<HTMLDivElement>(null)
  // const elementRef = useRef(null)
  const onClick = e => {
  // const onClick = useCallback(e => {
    e.stopPropagation()
    e.preventDefault()
    console.log(ID, e.target, e.target.checked, typeof e.target.checked)
    callback(db, v, pk)
  // }, [ID, callback, db, v, pk, park])
  }
  // useEffect(() => {
  //   const element = elementRef.current
  //   if (!element) return
  //   element.addEventListener('click', onClick)
  //   // window.addEventListener('click', onClick)
  //   return () => element.removeEventListener('click', onClick)
  // }, [onClick])
  const key = `${db}${u}${v}${pk}`
  const keyTitle = `${u}${verb}title`
  const keyDesc = `${u}${verb}desc`
  // if (title && I && I.title) pTitle.key=`${u}${verb}title`
  // if (desc &&  I && I.desc)  pDesc.key =`${u}${verb}desc`
  pTitle.className = pTitle.className.join(' ')
  pDesc.className = pDesc.className.join(' ')
  let display = '', ph = {}
  if (title) {
    ph = pTitle
    if (_.Q_.includes(v) && count) display = count ? `${count} ` : `${park[v][db][_.PUB]} `
    display += title===true ? (I.title||'') : title
  }
  else if (desc) {
    ph = pDesc
    display = desc===true ? (_.Q_.includes(v) ? `${master[_verb].i}` : I.desc) : desc
    if (v=='follows' || v=='follow') {
      const r = prop.r
      const from = r.from
      const date = new Date(r.modified*1000)
      const cached = cache(from)
      const bigIds = park.login?.user?.default || {}
      if (bigIds[from] && bigIds[from]!='find') display = bigIds[from].name || bigIds[from].username
      else if (cached && cached!='find') display = cached.name || cached.username
      else if (cached=='find') display = `${master.not.i} ${master.find.i}`
      else if (date instanceof Date && !isNaN(date)) display = date.toDateString()
      else display = master.new.i
    }
  }
  const content=[__DEV__ && ` ${prop.row ? 'row' : v} header`]
  ph.id = pk ? `${db}${v}${pk}` : `${db}${v}`
  // const print = pk<0 ? true : !window.opener
  const paramCart = typeof param.cart != 'undefined'
  const print = pk<0 ? true : (!window.opener || paramCart)
  // const print = (pk<0 || isNaN(pk)) ? true : (!window.opener || paramCart)
  // let print = pk<0 ? true : (!window.opener || paramCart)
  // const print = (pk<0 || (pk && isNaN(pk))) ? true : (!window.opener || paramCart)
  // if (pk && isNaN(pk)) print=false
  // if (pk && isNaN(pk)) debugger
  // if (prop.master.param.cart) debugger
  // if (window.opener) debugger
  prop.print && content.push(
    <div
      /* ref = {ref} */
      /* ref = { elementRef } */
      onClick = { onClick }
      key = { key }
    >
      {print && <div {...ph}>{display}{display.length==0 || storeConfig || !_.Q_.includes(v) ?  '' : (collapse ? darr : uarr)}</div>}
      {print && <div className='center'>{prop.before}</div>}
      <div className='theme flex space'>
        {prop.content}
      </div>
      {prop.after}
    </div>
  )
  // if (v=='welcome')debugger
  return (
    <div
      className = { headerClass.join(' ') }
    >
      { content }
    </div>)
}
export default Header
